import { render, staticRenderFns } from "./LanguageNavigation.vue?vue&type=template&id=50f6a090&scoped=true&"
import script from "./LanguageNavigation.vue?vue&type=script&lang=js&"
export * from "./LanguageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LanguageNavigation.vue?vue&type=style&index=0&id=50f6a090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6a090",
  null
  
)

export default component.exports